interface ErrorFallbackProps {
  message?: string
  onRetry?: () => void
}

export const ErrorFallback = ({ message, onRetry }: ErrorFallbackProps) => (
  <div className="rounded-2xl border border-destructive/20 bg-destructive/5 px-6 py-8 text-center space-y-3">
    <p className="text-sm font-medium text-destructive">
      Something went wrong
    </p>
    <p className="text-xs text-muted-foreground max-w-sm mx-auto">
      {message
        ? 'Unable to load this section right now.'
        : 'Unable to connect to the Engine API. Check that the backend is running.'}
    </p>
    {onRetry && (
      <button
        onClick={onRetry}
        className="mt-2 rounded-xl border border-border bg-background px-4 py-1.5 text-sm text-foreground hover:bg-muted/60 transition-colors"
      >
        Retry
      </button>
    )}
  </div>
)
